import { Routes } from '@angular/router';
import { QuoteToolModes, quoteToolPaths } from '@lx/quote-tool/shared/routing';

export const quoteToolRoutes: Routes = [
  {
    title: 'Online Enrolment: Book your language course abroad | ESL',
    path: quoteToolPaths.get(QuoteToolModes.quickQuoteTool),
    loadChildren: () => import('@lx/quote-tool/form').then((m) => m.QuoteToolFormModule),
  },
];
